import { activePipelineConfigLoadOptions } from 'features/pipelineConfig/activePipelineConfigLoadOptions'
import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'

type PipelineConfigStatusEntry = {
  entry: {
    id: string
  }
}

interface UseActivePipelineConfigIdResult {
  activePipelineConfigId: string | undefined
  isLoading: boolean
}

/**
 * The site's ACTIVE pipeline-config entry id, for callers that live outside
 * the documents page's `PipelineConfigProvider` (e.g. FIM evidence panels
 * building document-viewer links). Undefined while no active config is loaded.
 */
export const useActivePipelineConfigId = (
  siteID: string | undefined
): UseActivePipelineConfigIdResult => {
  const loadOptions = useMemo(
    () => (siteID ? activePipelineConfigLoadOptions(siteID) : undefined),
    [siteID]
  )
  const { data } =
    useGetRolodexEntriesByLoadOptions<PipelineConfigStatusEntry[]>(loadOptions)

  return {
    activePipelineConfigId: data?.[0]?.entry.id,
    isLoading: siteID !== undefined && data === undefined,
  }
}
